<template>
  <div class="carnival-2020-container cooperate-wrapper" v-pv>
    <navigator-top :nav-lists="navLists" />
    <div data-anchor="CITY">
      <div class="module-title" />
      <div class="cooperate-text">
        <div>【爱奇艺动漫游戏嘉年华】</div>
        <p>
          爱奇艺动漫游戏嘉年华（iQIYI FUN
          CARNIVAL，简称IFC），是爱奇艺推出的二次元线下活动。活动分为城市漫展、IP主题展、动漫音乐演出三大模块。整合优质动漫游戏IP和原创动漫游戏资源，力求打造中国最具价值、最具品质的二次元线下活动。更多商务合作，请接洽：
          <a href="mailto:IFC@qiyi.com">IFC@qiyi.com</a>
        </p>
        <div>【创作者入驻】</div>
        <p>
          爱奇艺动漫直播、社区创作者生态，拥有丰富的平台资源及扶持计划，及优质的孵化团队。现面向商业伙伴开放合作，诚招虚偶MCN代运营公司，同时也欢迎个人爱好者入驻。商务洽谈请联系：
          <a href="mailto:sunyang@qiyi.com">sunyang@qiyi.com</a>
        </p>
        <div>【IP授权合作】</div>
        <p>
          爱奇艺动漫拥有题材丰富的高人气原创IP，面向商业伙伴开放IP资源合作，不限于品牌合作授权、垂直衍生品授权、线下实景类授权、展会摊位合作等灵活合作形式。欢迎垂询：
          <a href="mailto:yuanyue01@qiyi.com">yuanyue01@qiyi.com</a>
        </p>
      </div>
      <div class="cooperate-works">
        <div class="cooperate-item" v-for="(item, index) in cooperates" :key="index">
          <img :src="item.img" alt="作品图" />
          <div class="work">《{{ item.name }}》</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { initPingback } from '@iqiyi-h5act/act-pingSdk'
import { MOCK_COOPERATE } from './mock-data'
import NavigatorTop from './main-kv/navigator-top.vue'

export default {
  components: { NavigatorTop },
  data() {
    return {
      navLists: [
        {
          label: '返回首页',
          value: 'goIndex',
        },
        {
          label: '商务合作',
          value: 'CITY',
        },
        {
          label: '广告合作',
          value: 'goGG',
        },
      ],
      cooperates: MOCK_COOPERATE,
    }
  },
  methods: {},
  mounted() {
    initPingback({
      cxid: '4553',
      rpage: 'activity_45533_hz',
    })
  },
}
</script>
<style lang="less">
@import './index.less';
.cooperate-wrapper {
  padding-top: 18rem;
  padding-bottom: 22rem;
  overflow-y: hidden;
  background: url('./images/bg-blue.png') repeat center center;
  background-size: 26rem 26rem;
  .module-title {
    background-image: url('./images/title-sw.png');
  }
  .cooperate-text {
    width: 110.2rem;
    margin: 0 auto 5rem;
    font-size: 1.6rem;
    font-family: HYYakuHei55W;
    color: #ffffff;
    line-height: 3.5rem;
    p {
      margin-bottom: 4rem;
    }
    a {
      color: #ffa9f7;
      user-select: text;
    }
    div {
      font-weight: 750;
      margin-bottom: 2rem;
    }
  }
  .cooperate-works {
    max-width: 111.6rem;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }
  .cooperate-item {
    box-sizing: border-box;
    display: inline-block;
    width: 24.6rem;
    height: 31.4rem;
    overflow: hidden;
    background: #7de4fe;
    border: 0.4rem solid #7de4fe;
    box-shadow: 1.5rem 1.5rem #1f037a;
    margin-bottom: 4rem;
    margin-right: 3.3rem;
    font-size: 0;
    img {
      width: 100%;
      height: 26rem;
    }
    .work {
      width: 100%;
      padding: 1rem 0 1.2rem;
      text-align: center;
      color: #330ad6;
      font-size: 1.8rem;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
